import loadable from '@loadable/component';
import { WithLazyHydration } from '../../WithLazyHydration';

const OneUpLoadable = loadable(() => import('./OneUp'), {
  resolveComponent: components => components.OneUp
});

export const OneUp = WithLazyHydration(OneUpLoadable, {
  name: 'OneUp'
});
